export default "__VITE_ASSET__Di53nfZz__"